import { v4 as uuid } from 'uuid';

import {
  VisualWorkerMessageResponse,
  VisualWorkerMessageType,
  VisualWorkerParams,
  VisualWorkerResponse,
} from './worker/workerTypes';
import { CorsWorker as Worker } from './worker/CorsWorker';

const visualWorker = new Worker(new URL('./worker/visualWorker.ts', import.meta.url)).getWorker();

// TODO: Simplify structure for easier re-use for other worker functions when / if others are
//  needed
const workerReturnVal = {
  buildGroups: (
    { nodes, filterValues }: VisualWorkerParams<VisualWorkerMessageType.BuildGroups>,
  ) => new Promise<VisualWorkerResponse<VisualWorkerMessageType.BuildGroups>>((resolve) => {
    // Creates a unique ID for this request, so we can handle the response for this ID once, and
    // remove the listener once it's been fired
    const id = uuid();

    function handleResponse(event: MessageEvent<VisualWorkerMessageResponse>) {
      if (
        event.data.type === VisualWorkerMessageType.BuildGroups &&
        event.data.id === id
      ) {
        resolve(event.data.data);

        visualWorker.removeEventListener('message', handleResponse);
      }
    }

    visualWorker.addEventListener('message', handleResponse);

    visualWorker.postMessage({
      type: VisualWorkerMessageType.BuildGroups,
      id,
      data: {
        nodes,
        filterValues,
      },
    });
  }),
};

/**
 * Accesses the Visual Web Worker to run CPU heavy workloads on a background thread to not block UI
 * responsiveness / rendering.
 */
export const useVisualWorker = () => workerReturnVal;
